import { Table } from '@modules/tours/table-toolkit/classes/table';
import { NightDateArea } from '../../classes/night-date-table/night-date-area';

import { LoadingStatus } from '@modules/tours/table-toolkit/interfaces/loading-status';

export class LoadingMatrixState {
  matrix?: Table<LoadingStatus, Date, number>;
  area?: NightDateArea;
}
